import { useHistory, useLocation } from 'react-router-dom';

import { getMailboxFolderItemByPath, getMailboxInboxPath } from '../helpers';

/**
 * Resolves the folder a mailbox view was opened from, so compose and message
 * detail can send the user back to the list they were reading.
 */
const useMailboxBackPath = () => {
    const history = useHistory();
    const location = useLocation();
    const folder = getMailboxFolderItemByPath(location.state?.mailboxFolderPath);
    const backPath = location.state?.mailboxComposeBackPath
        || folder?.path
        || getMailboxInboxPath();

    return {
        backPath,
        backFolder: folder?.key || 'inbox',
        backFolderTitleKey: location.state?.mailboxComposeBackPath
            ? 'Message'
            : folder?.titleKey,
        goBack: () => history.push(backPath),
    };
};

export default useMailboxBackPath;
